import Vue from "vue";
import Vuex from "vuex";
import { SystemSettingsStore, UserStore } from "nx-libs";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    systemSettingsStore: SystemSettingsStore,
    userStore: UserStore
  }
});
